import { motion } from "framer-motion";
import { FEATURES } from "../../data";
import { Reveal } from "./Reveal";

export const WhyUs = () => (
    <section
        id="porque"
        data-testid="whyus-section"
        className="py-20 md:py-28 px-4 bg-gradient-to-b from-transparent via-lightpink/15 to-transparent"
    >
        <div className="max-w-6xl mx-auto">
            <Reveal className="text-center mb-14">
                <span className="font-label uppercase tracking-[0.25em] text-xs text-strawred font-semibold">
                    Nuestro Sabor
                </span>
                <h2 className="mt-3 font-display font-bold text-4xl md:text-6xl text-gradient-pink">
                    ¿Por qué elegirnos?
                </h2>
            </Reveal>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {FEATURES.map((f, i) => (
                    <Reveal key={f.title} delay={i * 0.12}>
                        <motion.div
                            whileHover={{ y: -8 }}
                            data-testid={`feature-card-${i}`}
                            className={`h-full bg-white rounded-3xl p-8 md:p-10 shadow-xl shadow-hotpink/10 border border-pink-50 ${
                                i === 1 ? "md:-translate-y-6" : ""
                            }`}
                        >
                            <div className="text-5xl md:text-6xl mb-5">
                                {f.icon}
                            </div>
                            <h3 className="font-display font-bold text-2xl text-[#1a0a10]">
                                {f.title}
                            </h3>
                            <p className="mt-3 text-[#6e4b58] font-medium">
                                {f.desc}
                            </p>
                        </motion.div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
